// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1Wu3l","label":"SetPasswdForm_label__2WFJm"};